import cx from "classnames";
import React from "react";
import styles from "./CreditHoursBadge.module.css";

type BadgeSize = "lg" | "sm";
const DEFAULT_SIZE: BadgeSize = "lg";

type BadgeProps = {
  ceUnits?: number;
  size?: BadgeSize;
};

const CreditHoursBadge = ({ ceUnits, size = DEFAULT_SIZE }: BadgeProps) => {
  const ceLabel = ceUnits && ceUnits > 0 ? `${ceUnits} CE` : "non CE event";

  let creditLabel = "";
  if (ceUnits === 1) {
    creditLabel = "credit";
  } else if (ceUnits && ceUnits > 1) {
    creditLabel = "credits";
  }

  return (
    <div className={cx(styles.root, styles[size])}>
      <div>
        <div className={styles.ceWrapper}>{ceLabel}</div>
        <div className={styles.creditsWrapper}>{creditLabel}</div>
      </div>
    </div>
  );
};

export default CreditHoursBadge;
